import { FilterTypes } from '../actions/filterAction';

const defaultState = {
  dataFilterINC: {},
  dataFilterRITM: {},
  dataFilterApproval: {},
};

const filterReducer = (state = defaultState, action: any) => {
  const { dataFilterINC, dataFilterRITM, dataFilterApproval } = action;
  
  switch (action.type) {
    case FilterTypes.GET_LIST_FILTER_INC_SUCCESS:
      return {
        ...state,
        dataFilterINC
      }

    case FilterTypes.GET_LIST_FILTER_RITM_SUCCESS:
      return {
        ...state,
        dataFilterRITM
      }

    case FilterTypes.GET_LIST_FILTER_APPROVAL_SUCCESS:
      return {
        ...state,
        dataFilterApproval
      }

  }

  return state;
};

export default filterReducer;
